export const MortgageInterestTerms = [
  'threeMonth',
  'oneYear',
  'twoYear',
  'threeYear',
  'fourYear',
  'fiveYear',
  'sevenYear',
  'tenYear',
] as const

export type MortgageInterestTerm = (typeof MortgageInterestTerms)[number]

export const InterestTerms = [
  'threeMonth',
  'sixMonth',
  'oneYear',
  'twoYear',
  'threeYear',
  'fourYear',
  'fiveYear',
  'sevenYear',
  'tenYear',
] as const

export type InterestTerm = (typeof InterestTerms)[number]

export const isInterestTerm = (value: string): value is InterestTerm => {
  return InterestTerms.includes(value as InterestTerm)
}

export const isMortgageInterestTerm = (value: string | null): value is MortgageInterestTerm => {
  return MortgageInterestTerms.includes(value as MortgageInterestTerm)
}

export const MortgageInterestTermMonths: Record<MortgageInterestTerm, number> = {
  threeMonth: 3,
  oneYear: 12,
  twoYear: 24,
  threeYear: 36,
  fourYear: 48,
  fiveYear: 60,
  sevenYear: 84,
  tenYear: 120,
}

// Lengths a loan terms period (villkorsperiod: how long a discount applies) can be scheduled for, in months.
// Never shorter than a year, also after a three month interest term.
export const LoanTermsLengthsInMonths = [12, 24, 36, 48, 60, 84, 120] as const

export type LoanTermsLengthInMonths = (typeof LoanTermsLengthsInMonths)[number]

export const MAX_LOAN_TERMS_DISCOUNT_BPS = 1000

/** Loan terms lengths offered with an interest term: one year after threeMonth, otherwise as long as the term. */
export const allowedLoanTermsLengths = (interestTerm: MortgageInterestTerm | ''): LoanTermsLengthInMonths[] =>
  LoanTermsLengthsInMonths.filter(
    (months) => !interestTerm || months === Math.max(12, MortgageInterestTermMonths[interestTerm]),
  )
